import React from 'react';
import { Switch, Route } from 'react-router-dom';

import WithLayout from '../components/WithLayout';
import ScrollToTop from './ScrollToTop';
import GA from '../utils/googleAnalytics';

import Home from './home';
import SubProduct from './subProduct';
import SelectPlan from './selectPlan';
import PlanInfo from './planInfo';
import AllPlans from './allPlans';
import SelectAddress from './selectAddress';
import AddAddress from './addAddress';
import PaymentMethods from './paymentMethods';
import Summary from './summary';
import Congratulations from './congratulations';
import CongratulationsCar from './CongratulationsCar';
import ErrorPage from './errorPage';
import Beneficiaries from './beneficiaries';
import Price from './price';
import Patente from './patente';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setErrorMessage } from '../redux/errors';
import { mapErrorMessage } from '../utils';
import Dismiss from './dismiss';
import PetType from './petType';
import Activity from './activity';

const userAgent = window.navigator.userAgent;
const regex = new RegExp(/(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/);
const isIE = userAgent.match(regex) ? true : false;

export default function Router() {
  const dispatch = useDispatch();
  const history = useHistory();

  if (isIE && history.location.pathname !== '/error') {
    dispatch(setErrorMessage(mapErrorMessage('invalidBrowser')));
    history.push(`/error`);
  }

  return (
    <>
      {GA.init() && <GA.RouteTracker />}
      <ScrollToTop />
      <Switch>
        <Route path='/' exact>
          <WithLayout>
            <Home isIE={isIE} />
          </WithLayout>
        </Route>
        <Route path='/:type/planes' exact>
          <WithLayout>
            <SelectPlan />
          </WithLayout>
        </Route>
        <Route path='/:type/opciones'>
          <WithLayout>
            <SubProduct />
          </WithLayout>
        </Route>
        <Route path='/:type/detalles'>
          <WithLayout>
            <PetType />
          </WithLayout>
        </Route>
        <Route path='/:type/planes/todos'>
          <WithLayout>
            <AllPlans />
          </WithLayout>
        </Route>
        <Route path='/beneficiarios'>
          <WithLayout>
            <Beneficiaries />
          </WithLayout>
        </Route>
        <Route path='/planInfo'>
          <WithLayout>
            <PlanInfo />
          </WithLayout>
        </Route>
        <Route path='/domicilio' exact>
          <WithLayout>
            <SelectAddress />
          </WithLayout>
        </Route>
        <Route path='/domicilio/nuevo'>
          <WithLayout>
            <AddAddress />
          </WithLayout>
        </Route>
        <Route path='/resumen'>
          <WithLayout>
            <Summary />
          </WithLayout>
        </Route>
        <Route path='/medios-de-pago'>
          <WithLayout>
            <PaymentMethods />
          </WithLayout>
        </Route>
        <Route path='/felicitaciones'>
          <WithLayout>
            <Congratulations />
          </WithLayout>
        </Route>
        <Route path='/felicitacionesautos'>
          <WithLayout>
            <CongratulationsCar />
          </WithLayout>
        </Route>
        <Route path='/baja'>
          <WithLayout>
            <Dismiss />
          </WithLayout>
        </Route>
        <Route path='/error'>
          <WithLayout>
            <ErrorPage />
          </WithLayout>
        </Route>
        <Route path='/:type/actividad'>
          <WithLayout>
            <Activity />
          </WithLayout>
        </Route>
        <Route path='/:type/cotizacion'>
          <WithLayout>
            <Price />
          </WithLayout>
        </Route>
        <Route path='/:type/datosauto'>
          <WithLayout>
            <Patente />
          </WithLayout>
        </Route>
      </Switch>
    </>
  );
}
